import { useState, useEffect } from 'react'
import { supabase } from '../../shared/lib/supabase'

interface TrialStatus {
  tier: string | null
  trialDaysLeft: number | null
  subscriptionStatus: string | null
  loading: boolean
}

export function useTrialStatus(): TrialStatus {
  const [tier, setTier] = useState<string | null>(null)
  const [trialDaysLeft, setTrialDaysLeft] = useState<number | null>(null)
  const [subscriptionStatus, setSubscriptionStatus] = useState<string | null>(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    async function load() {
      try {
        const { data } = await supabase
          .from('users')
          .select('tier, trial_ends_at, subscription_status')
          .single()

        if (data) {
          setTier(data.tier)
          setSubscriptionStatus(data.subscription_status)
          if (data.tier === 'trial' && data.trial_ends_at) {
            const days = Math.max(0, Math.ceil(
              (new Date(data.trial_ends_at).getTime() - Date.now()) / (1000 * 60 * 60 * 24),
            ))
            setTrialDaysLeft(days)
          }
        }
      } catch {
        // Ignore — will show no banner
      } finally {
        setLoading(false)
      }
    }
    load()
  }, [])

  return { tier, trialDaysLeft, subscriptionStatus, loading }
}
